import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import index from '@/components/Index'
import Mobile from '@/components/Mobile'
import List from '@/components/List'
import Video from '@/components/Video'
import Course from '@/components/index/Course'
import Eval from '@/components/index/Eval'
import Evaling from '@/components/index/Evaling'
import Cert from '@/components/index/Cert'
import Achieve from '@/components/index/Achieve'
import Sumup from '@/components/index/Sumup'
import Detail from '@/components/Detail'
import Help from '@/components/Help'
import HelpDetail from '@/components/HelpDetail'
import AboutUs from '@/components/AboutUs'
import Userinfo from '@/components/Userinfo'

import Test from '@/components/Test'


Vue.use(Router)

export default new Router({
  routes: [
    {path : '/', name: 'index',component: index,meta: {title: '首页',requireAuth:true,},
      children:[
        {path : 'Course', name: 'Course',component: Course,meta: {title: '课程列表',requireAuth:true,}},
        {path : 'Eval', name: 'Eval',component: Eval,meta: {title: '课程测评',requireAuth:true,}},
        {path : 'Evaling', name: 'Evaling',component: Evaling,meta: {title: '课程测评',requireAuth:true,}},
        {path : 'Cert', name: 'Cert',component: Cert,meta: {title: '我的证书',requireAuth:true,}},
        {path : 'Achieve', name: 'Achieve',component: Achieve,meta: {title: '我的成就',requireAuth:true,}},
        {path : 'Sumup', name: 'Sumup',component: Sumup,meta: {title: '研修总结',requireAuth:true,}},
        { path: '/', redirect: 'Course'}
      ]
    },
    {path : '/Login', name: 'Login',component: Login,meta: {title: '登录'}},
    {path : '/Video', name: 'Video',component: Video,meta: {title: '课程详情',requireAuth:true,}},


    {path : '/Mobile', name: 'Mobile',component: Mobile,meta: {title: '重置密码'}},
    {path : '/List', name: 'List',component: List,meta: {title: '课程列表',requireAuth:true,}},

    {path : '/Detail', name: 'Detail',component: Detail,meta: {title: '课程详情',requireAuth:true,}},

    {path : '/Test', name: 'Test',component: Test,meta: {title: 'test',requireAuth:true,}},
    {path : '/Help', name: 'Help',component: Help,meta: {title: '帮助中心'}},
    {path : '/AboutUs', name: 'AboutUs',component: AboutUs,meta: {title: '关于我们'}},
    {path : '/HelpDetail', name: 'HelpDetail',component: HelpDetail,meta: {title: '文章详情'}},
    {path : '/Userinfo', name: 'Userinfo',component: Userinfo,meta: {title: '修改资料',requireAuth:true,}},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js